module.exports = __webpack_public_path__ + "a7b72768e0732449e5f8373e77fc3ad0.pdf";